import React from 'react';

import fetch from './fetch';

import utils from '../utils';

import {Icon, Tooltip} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 30},
    {key:'orgName', label: '部门名称', width: 80},
    {key:'employeeName', label: '教师姓名', width: 80},
    {key:'employeeCode', label: '教师工号', width: 80},
    {key:'reportName', label: '报告名称', width: 150},
    {
        key:'identity', 
        label: '标识',
        render: (d) => {
            if (d === 1) {
                return '近一年';
            } else if (d === 2) {
                return '近两年';
            } else if (d === 3) {
                return '近三年';
            } else if (d === 4) {
                return '近四年';
            } else if (d === 5) {
                return '近五年';
            } else if (d === 5) {
                return '其他';
            }
        }
    },
    {
        key: 'dataSource',
        label: '数据来源',
        render: (d) => {
            if (d === 1) {
                return '按学期三方汇总数据';
            }
        }
    },
    {key:'bgTermName', label: '报告开始学期', width: 100},
    {key:'endTermName', label: '报告结束学期', width: 100},
    {key:'termName', label: '学期', width: 100},
    {key:'batchNo', label: '批次', render: (d) => { return <Tooltip title={d}>{d}</Tooltip> }},
    {key:'createTime', label: '生成时间', width: 80},
    {key:'', label: '浏览下载', width: 80, render: (d,row)=>{
       return <a type="primary" style={{width:'100%'}} onClick={()=> {
            const idJoinBase64 = btoa(row.id);
            window.open(`${fetch.base}teacher/teaching/quality/report/print/${idJoinBase64}`, '_blank')
        }}>
            <Icon type="eye"></Icon>
            在线预览</a>
    }},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('teacher/teaching/quality/report/query?'+ params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const remove = (d) => {
    return fetch.post('teacher/teaching/quality/report/delete', d)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const settingSave = (d) => {
    return fetch.post('teacher/teaching/quality/report/setting/save', d)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const getSetting = () => {
    return fetch.get('teacher/teaching/quality/report/setting/get')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    }) 
}

const generate = () => {
    return fetch.get('teacher/teaching/quality/report/generate')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const fileUpload = () => {
    return `${fetch.base}teacher/teaching/quality/report/file`
}

const fileDelete = (ids) => {
    return fetch.post(`teacher/teaching/quality/report/file/delete`, ids);
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    querySearch,
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
    remove,
    settingSave,
    getSetting,
    generate,
    fileUpload,
    fileDelete
}